<template lang="pug">
    .conteudo
        .linha(style='margin: 0px')
            .coluna
                title-component(:label='$route.meta.titulo')

        .linha(style='margin-top: 0px')
            .coluna
                breadcrumb-component(:list="migracaoProcessos")

        .linha
            .coluna
                filter-basic-component(
                    @filtro:pesquisar='handleFilter'
                )

        .linha
            .coluna
                MigracaoProcessoTableComponent(
                    :headers="headers"
                    :data="paginatedGerentes"
                    :paginacao="paginacao"
                    :is-loading="isLoading"
                    @table:page-changed="checkPaginationChange"
                    @action:visualizar='visualizarProcessosGO'
                    @action:migrar='migrarProcessos'
                )

                VisualizarProcessosPorGOModal(
                    v-if="isModalVisible"
                    :show="isModalVisible"
                    :document='currentDocument'
                    :codigo-imovel='codigoImovelSelecionado'
                    :acao="acao"
                    @close='closeModal'
                    @update='handleUpdate'
                )

</template>

<script>
import {
    listarGerentesOperacionaisEContagemProcessos,
} from '@/services/processo.service.js';
import MigracaoProcessoTableComponent from '@/views/migracaoProcesso/components/MigracaoProcessoTableComponent.vue';
import VisualizarProcessosPorGOModal from '@/views/migracaoProcesso/components/VisualizarProcessosPorGOModal.vue';
import { migracaoProcessos } from '@/utils/breadcrumb.utils';
import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue';

export default {
    name: 'MigracaoProcessosComponent',
    components: {
        MigracaoProcessoTableComponent,
        VisualizarProcessosPorGOModal,
        FilterBasicComponent,
    },
    data() {
        return {
            headers: [
                { text: 'Gerente Operacional', field: 'nomeUsuario' },
                { text: 'Total', field: 'totalProcessos' },
                { text: 'Ações', field: 'acoes' },
            ],
            gerentesOperacionais: [],
            paginatedGerentes: [],
            filtroNome: '',
            acao: 'visualizar',
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
            },
            isLoading: false,
            isModalVisible: false,
            currentDocument: null,
            migracaoProcessos: migracaoProcessos,
            codigoImovelSelecionado: null,
        };
    },

    async created() {
        this.isLoading = true;
        await this.listaGODisponiveis();
        this.isLoading = false;
    },

    methods: {
       async listaGODisponiveis(filtro) {
            try {
                this.isLoading = true;

                const { gerentes, totalResults } =
                    await listarGerentesOperacionaisEContagemProcessos(filtro || null);

                if (Array.isArray(gerentes) && Array.isArray(gerentes[0])) {
                    this.gerentesOperacionais = gerentes[0];
                } else {
                    this.gerentesOperacionais = gerentes || [];
                }

                this.paginacao.total = totalResults;
                this.paginacao.numeroPaginas = Math.ceil(
                    this.paginacao.total / this.paginacao.quantidadePagina
                );

                this.atualizarPaginacao();

            } catch (error) {
                this.showToastError('Erro ao carregar Gerentes: ' + error);
            } finally {
                this.isLoading = false;
            }
        },


        showToast(mensagem, tipo) {
            this.$toast({
                showClose: true,
                message: mensagem,
                type: tipo
            });
        },

        showToastSucesso(mensagem) {
            this.showToast(mensagem, 'success');
        },

        showToastError(mensagem) {
            this.showToast(mensagem, 'error');
        },

        handleFilter(filtro) {
            this.filtroNome = filtro ? filtro.toLowerCase() : '';
            this.paginacao.pagina = 1;

            if (this.isCodigoImovel(filtro)) {
                this.codigoImovelSelecionado = filtro;
                this.listaGODisponiveis(filtro);
            } else {
                this.codigoImovelSelecionado = null;
                this.listaGODisponiveis();
            }
        },

        checkPaginationChange(page) {
            const currentPage = typeof page === "object" ? page.page : page; // Garante que seja um número
            this.paginacao.pagina = currentPage;
            this.atualizarPaginacao();
        },

        atualizarPaginacao() {
            const startIndex = (this.paginacao.pagina - 1) * this.paginacao.quantidadePagina;
            const endIndex = startIndex + this.paginacao.quantidadePagina;

            let gerentesFiltrados = [];

            if (this.isCodigoImovel(this.filtroNome)) {

                gerentesFiltrados = this.gerentesOperacionais;
            } else {

                gerentesFiltrados = this.gerentesOperacionais.filter((go) => {
                    const nome = go.nomeUsuario ? go.nomeUsuario.toLowerCase() : '';
                    return nome.includes(this.filtroNome);
                });
            }

            this.paginatedGerentes = gerentesFiltrados.slice(startIndex, endIndex);

            this.paginacao.total = gerentesFiltrados.length;
            this.paginacao.numeroPaginas = Math.ceil(
                this.paginacao.total / this.paginacao.quantidadePagina
            );
        },


        visualizarProcessosGO(gerente) {
            if(gerente.totalProcessos === 0) {
                this.showToastError('Não existem processos vinculados ao Gerente Operacional: ' + gerente.nomeUsuario);
                return;
            }
            this.acao = 'visualizar';
            this.currentDocument = gerente;
            this.isModalVisible = true;
        },

        closeModal() {
            this.isModalVisible = false;
        },

        async handleUpdate() {
            await this.listaGODisponiveis();
            this.closeModal();
        },

        migrarProcessos(gerente) {
            this.currentDocument = gerente;
            this.isModalVisible = true;
            this.acao = 'migrar';
        },
        isCodigoImovel(valor) {
            return typeof valor === 'string' && valor.toUpperCase().startsWith('SP-');
        }
    },
};
</script>


<style lang="scss" scoped>
.conteudo {
    padding: 20px;
}

.linha {
    margin-bottom: 20px;
}

.coluna {
    display: flex;
    flex-direction: column;
}

.botao-criar {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: var(--primary-green);
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: var(--primary-green);
    }

    i {
        margin-right: 5px;
    }
}

.filtro-container {
    display: flex;
    align-items: center;

    input[type='text'] {
        margin-right: 10px;
        padding: 5px;
        border: 1px solid #ccc;
        border-radius: 4px;
        flex: 1;
    }

    button {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        background-color: var(--primary-green);
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: var(--primary-green);
        }

        i {
            margin-right: 5px;
        }
    }
}

.acao-container {
    display: flex;
    justify-content: space-between;

    button {
        margin-right: 5px;
        padding: 5px;
        background-color: var(--primary-green);
        color: var(--primary-green);
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: var(--primary-green);
        }

        i {
            margin-right: 5px;
        }
    }
}

.filtro-border {
    border: 1px solid var(--primary-green);
    background-color: var(--primary-green);
    padding: 10px;
    border-radius: 5px;
}

.cadastro-position {
    display: flex;
    justify-content: flex-end;
}

.botao-cadastrar {
    height: 32px;
}
</style>
